import {IPois} from "../../varibles/interface";
import {createSliceSelectors} from "../selectors";

export const NAME_SLICE = 'location'

export interface LocationState {
    allLocations: IPois[]
    allLocationsLoadedAt?: number
    loadingAllLocations: boolean
    data: IPois[]
    locations: IPois[]
    locationsLoadedAt?: number
    loadingLocations: boolean

    loading: boolean
}

export const initialState: LocationState = {
    allLocations: [],
    allLocationsLoadedAt: undefined,
    loadingAllLocations: false,
    data: [],
    locations: [],
    locationsLoadedAt: undefined,
    loadingLocations: false,

    loading: false,
}

// Location
export const selectLocation = createSliceSelectors(NAME_SLICE, initialState);
